import { Box, Typography } from "@mui/material"
import { DamsColors } from "../styles/DamsColors"



function CollapseTableLabelItem({
    title,
    value,
    selected = false
}: Readonly<{
    title?: string,
    value?: string
    selected?: boolean
}>) {


    return (
        <Box
            display={'flex'}
            // border={"1px solid blue"}
            gap={0.4} >

            <Typography
                color={selected ? DamsColors.Text.Highlight : DamsColors.Text.LabelTextLight}
                fontFamily={'Inter'}
                fontSize={14}
                fontWeight={600}
            >
                {`${title ?? 'Label Title'}  :`}
            </Typography>

            <Typography
                color={selected ? DamsColors.Text.Highlight : DamsColors.Text.LabelTextLight}
                fontFamily={'Inter'}
                fontSize={14}
                fontWeight={400}
            >
                {` ${value ?? 'Value'}`}
            </Typography>
        </Box>
    )
}

export { CollapseTableLabelItem }
